import {
  CUSTOMER_ORDER_ACTIVE_STATUS_VALUES,
  type OrderStatus,
} from '../../types/order';

// UI-only progress rails for customer orders. Backend remains the source of
// truth for allowed transitions; these arrays only define detail-page order.
export const CUSTOMER_ORDER_PROGRESS_STATUSES: OrderStatus[] =
  CUSTOMER_ORDER_ACTIVE_STATUS_VALUES.filter(
    (status) => status !== 'ON_HOLD' && status !== 'CANCELLED',
  );

export const LEGACY_CUSTOMER_ORDER_PROGRESS_STATUSES: OrderStatus[] = [
  'NEW_INQUIRY',
  'QUOTE_SENT',
  'AWAITING_CONFIRMATION',
  'QUOTE_REQUESTED',
  'PROFORMA_SENT',
  'CONFIRMED',
  'ORDER_CONFIRMED',
  'RESERVED',
  'ORDERED_FROM_SUPPLIER',
  'MANUFACTURING',
  'PARTIALLY_READY',
  'READY_FOR_DISPATCH',
  'IN_TRANSIT',
  'CUSTOMS_CLEARANCE',
  'IN_DELIVERY',
  'PARTIALLY_DELIVERED',
  'DELIVERED',
];

const LEGACY_ONLY_CUSTOMER_ORDER_PROGRESS_STATUSES = new Set<OrderStatus>(
  LEGACY_CUSTOMER_ORDER_PROGRESS_STATUSES.filter(
    (status) => !CUSTOMER_ORDER_PROGRESS_STATUSES.includes(status),
  ),
);

const usesLegacyCustomerOrderProgress = (currentStatus: OrderStatus) => (
  LEGACY_ONLY_CUSTOMER_ORDER_PROGRESS_STATUSES.has(currentStatus)
);

export const getCustomerOrderProgressStatuses = (
  currentStatus: OrderStatus,
  _statusHistory: Array<{ status?: string | null }> = [],
): OrderStatus[] => {
  return usesLegacyCustomerOrderProgress(currentStatus)
    ? LEGACY_CUSTOMER_ORDER_PROGRESS_STATUSES
    : CUSTOMER_ORDER_PROGRESS_STATUSES;
};
